// Section 21 and 26 "Sharing runs" (stream G): the copyable text summary: the seed, the
// outcome, the options, the tags and the character sketch, plus the score line.
import type { LedgerVM } from '../../viewModels/ledger';
import { fillSketch, ledgerOptionsLine, ledgerText as t, seasonLabel, tagLabel } from '../text/en';

export function outcomeLine(vm: LedgerVM): string {
  const o = vm.outcome;
  const at = o.at === null ? '' : ` (${t.when(seasonLabel[o.at.season], o.at.year)})`;
  switch (o.kind) {
    case 'won':
      return `${t.won}${at}.`;
    case 'lost':
      return `${t.lost}${o.reason === null ? '' : `: ${t.lossReason[o.reason]}`}${at}.`;
    case 'ongoing':
      return t.ongoing;
  }
}

export function summaryText(vm: LedgerVM): string {
  const tags = vm.tags.length === 0 ? t.noTags : vm.tags.map((tag) => tagLabel[tag]).join(', ');
  return [
    t.summaryHeading,
    `${t.seed}: ${vm.outcome.seed}`,
    outcomeLine(vm),
    `${t.options}: ${ledgerOptionsLine(vm.outcome.options)}${vm.outcome.ironman ? `, ${t.ironman}` : ''}`,
    `${t.tags}: ${tags}`,
    '',
    vm.sketch.map(fillSketch).join(' '),
    '',
    t.scoreLine(vm.score),
  ].join('\n');
}
